import { useToggle } from "client/hooks/utils/useToggle";
import { setSort } from "store/features/compress/actions";
import { compressSelector } from "store/features/compress/selectors/compressSelector";
import { CompressState } from "store/features/compress/types";
import { useAppDispatch, useAppSelector } from "store/store";
import { Sort } from "store/types/sort";

export const useSort = () => {
    const { sort } = useAppSelector(compressSelector, equalityFn);
    const dispatch = useAppDispatch();

    const { isOpen, toggle, onClose: close } = useToggle();

    const handleClick = (value: Sort) => {
        close();
        dispatch(setSort(value));
    };

    return { isOpen, toggle, close, handleClick, sort };
};

const equalityFn = (left: CompressState, right: CompressState) => {
    if (left.sort !== right.sort) return false;

    return true;
};
